var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 46 45"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 22.5,
  r: 22.5,
  fill: "#3DB460"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1.171,
  d: "M33.119 21.286h-9.31V12.38a.81.81 0 1 0-1.619 0v8.905h-9.31a.81.81 0 1 0 0 1.619h9.31v9.714a.81.81 0 1 0 1.62 0v-9.714h9.309a.81.81 0 1 0 0-1.62Z"
})));
export default SvgPlus;